import { getMatcher } from 'admin/lib/shortcuts'

export const Matchers = {
  lineItems: {
    removeCurrent: getMatcher(
      {
        name: 'Remove Current',
        group: 'Line Items'
      },
      'delete',
      {
        ctrlOrCommand: true,
        shift: true
      }
    ),
    add: getMatcher(
      {
        name: 'Add New',
        group: 'Line Items'
      },
      'a',
      {
        ctrlOrCommand: true,
        shift: true
      }
    ),
    duplicate: getMatcher(
      {
        name: 'Duplicate Current',
        group: 'Line Items'
      },
      'd',
      {
        ctrlOrCommand: true,
        shift: true
      }
    ),
    minimizeProduct: getMatcher(
      { name: 'Minimize Product', group: 'Line Items' },
      '`',
      {
        ctrlOrCommand: true
      }
    ),
    openLineItemSummary: getMatcher(
      { name: 'Open Line Item Summary', group: 'Line Items' },
      '\\',
      {
        ctrlOrCommand: true
      }
    ),
    toggleLineItemSummaryMinification: getMatcher(
      { name: 'Toggle Line Item Summary Minification', group: 'Line Items' },
      ['\\', '|'],
      {
        ctrlOrCommand: true,
        shift: true
      }
    ),
    toggleUnit: getMatcher({ name: 'Toggle Unit', group: 'Line Items' }, 'u', {
      ctrlOrCommand: true
    })
  },
  image: {
    next: getMatcher({ name: 'Next Image', group: 'Images' }, ']', {
      ctrlOrCommand: true
    }),
    previous: getMatcher({ name: 'Previous Image', group: 'Images' }, '[', {
      ctrlOrCommand: true
    }),
    rotateRight: getMatcher({ name: 'Rotate Right', group: 'Images' }, [';'], {
      ctrlOrCommand: true
    }),
    rotateLeft: getMatcher(
      { name: 'Rotate Left', group: 'Images' },
      [';', ':'],
      {
        ctrlOrCommand: true,
        shift: true
      }
    ),
    zoomIn: getMatcher({ name: 'Zoom In', group: 'Images' }, 'p', {
      ctrlOrCommand: true
    }),
    zoomOut: getMatcher({ name: 'Zoom out', group: 'Images' }, 'o', {
      ctrlOrCommand: true
    }),
    zoomReset: getMatcher({ name: 'Reset zoom level', group: 'Images' }, 'o', {
      ctrlOrCommand: true,
      shift: true
    }),
    toggleMarker: getMatcher({ name: 'Toggle Marker', group: 'Images' }, 'm', {
      ctrlOrCommand: true
    }),
    toggleOcrBoxes: getMatcher({ name: 'Toggle OCR', group: 'Images' }, 'l', {
      ctrlOrCommand: true
    })
  },
  form: {
    save: getMatcher({ name: 'Save Record', group: 'Form' }, 's', {
      ctrlOrCommand: true
    }),
    toggleDataView: getMatcher(
      { name: 'Toggle Raw/Enriched view', group: 'Form' },
      'e',
      {
        ctrlOrCommand: true
      }
    ),
    toggleShowRaw: getMatcher(
      { name: 'Toggle "Show Raw"', group: 'Form' },
      'e',
      {
        ctrlOrCommand: true,
        shift: true
      }
    ),
    jumpDown: getMatcher({ name: 'Jump Down', group: 'Form' }, 'arrowdown', {
      ctrlOrCommand: true
    }),
    jumpUp: getMatcher({ name: 'Jump Up', group: 'Form' }, 'arrowup', {
      ctrlOrCommand: true
    }),
    jumpTop: getMatcher({ name: 'Jump to Top', group: 'Form' }, 'arrowup', {
      ctrlOrCommand: true,
      shift: true
    }),
    jumpBottom: getMatcher(
      { name: 'Jump to Bottom', group: 'Form' },
      'arrowdown',
      {
        ctrlOrCommand: true,
        shift: true
      }
    )
  },
  copyAndPaste: {
    copyRecord: getMatcher(
      { name: 'Copy Record (Raw fields only)', group: 'Copy & Paste' },
      'c',
      { ctrlOrCommand: true, shift: true }
    ),
    copyRecordTopSectionOnly: getMatcher(
      {
        name: 'Copy Record (Top section, Raw fields only)',
        group: 'Copy & Paste'
      },
      'c',
      { ctrlOrCommand: true, shift: true, altOrOpt: true }
    ),
    pasteEmpty: getMatcher(
      { name: 'Paste Record (Empty Fields)', group: 'Copy & Paste' },
      'v',
      { ctrlOrCommand: true, shift: true }
    ),
    pasteAll: getMatcher(
      { name: 'Paste Record (All Fields)', group: 'Copy & Paste' },
      'b',
      { ctrlOrCommand: true, shift: true }
    )
  },
  infraction: {
    add: getMatcher({ name: 'Add Alert', group: 'Alerts' }, 'i', {
      ctrlOrCommand: true
    })
  },
  comments: {
    add: getMatcher({ name: 'View Comments', group: 'Comments' }, 'l', {
      ctrlOrCommand: true,
      shift: true
    })
  },
  qcr: {
    resendToQcr: getMatcher(
      {
        name: 'Resend to QCR',
        group: 'QCR'
      },
      'q',
      { ctrlOrCommand: true, shift: true }
    )
  }
}
